import { type FilterItem } from 'widgets/FilterEditor/model'

export const AutomationLogResultStatusKeys = new Set(['automationLogs.result'])

export const isAutomationLogResultStatusWidget = (filterItem: FilterItem) =>
  AutomationLogResultStatusKeys.has(filterItem.key)
